import { render, staticRenderFns } from "./procedure.vue?vue&type=template&id=1ebc8efb&"
import script from "./procedure.vue?vue&type=script&lang=js&"
export * from "./procedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports